// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { classNames, getTemplate } from '@progress/kendo-vue-common';
import { getItemValue } from './utils';
/**
 * Represents the default `ListItem` component.
 */

var ListItem = {
  name: 'list-item',
  props: {
    id: String,
    index: Number,
    dataItem: [Object, String, Number],
    textField: String,
    focused: Boolean,
    selected: Boolean,
    render: Object
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('itemclick', this.$props.index, e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var selected = this.$props.selected;
    var defaultRendering = h("li", {
      id: this.$props.id,
      attrs: this.v3 ? undefined : {
        id: this.$props.id,
        role: "option",
        "aria-selected": selected
      },
      role: "option",
      "aria-selected": selected,
      "class": classNames('k-item', {
        'k-state-selected': selected,
        'k-state-focused': this.$props.focused
      }),
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick
      }
    }, [getItemValue(this.$props.dataItem, this.$props.textField).toString()]);
    return getTemplate.call(this, {
      h: h,
      template: this.$props.render,
      defaultRendering: defaultRendering,
      additionalProps: this.$props,
      additionalListeners: {
        click: this.handleClick
      }
    });
  }
};
export { ListItem };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dropdowns/dist/es/common/ListItem.js
// module id = 810
// module chunks = 93